import * as moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { NumericFormat } from "react-number-format";
import { useHistory, useLocation } from "react-router-dom";
import ReactToPrint from "react-to-print";
import { Button, Modal, ModalBody } from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Col,
  Icon,
  Row,
} from "../../components/Component";
import Table from "../../components/react-table/Table";
import { GET, POST } from "../../helper/api";
import { getToken } from "../../helper/auth";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import { PN_STATIC_CATEGORY_SALARY_FOR_DRIVER, PN_STATIC_CATEGORY_SALARY_FOR_DRIVER_NAME, renderPageStyle } from "../../utils/Utils";
import { colTableCn, colTableNvvp } from "../employeemanager/components/SalaryPerMonthColTable";
import UpsertPITFeeComponent from "./Components/UpsertPITFeeComponent";
import { toast } from "react-toastify";


const PNReportDriverSalary = () => {
  const printRef = useRef();
  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [smOption, setSmOption] = useState(false);
  const [dataDriver, setDataDriver] = useState([]);
  const [summaryDriver, setSummaryDriver] = useState({});
  const [updatedAt, setUpdatedAt] = useState();
  const [pitFee, setPitFee] = useState(null);
  const [dataNvvp, setDataNvvp] = useState([]);
  const [summaryNvvp, setSummaryNvvp] = useState({});

  const [dataCn, setDataCn] = useState([]);
  const [summaryCn, setSummaryCn] = useState({});
  const [allowConfirmMonthYear, setAllowConfirmMonthYear] = useState(false);

  const [filter, setFilter] = useState({
    monthYear: searchParams.get('monthYear') || moment().format("YYYY-MM"),
  });

  const hidePersonalCostAndAdvance = moment(filter.monthYear, 'YYYY-MM').isSameOrAfter(moment('2026-07', 'YYYY-MM'), 'month');


  useEffect(() => {
    GET(
      `/pn/check-confirm-salary`,
      { monthYear: filter.monthYear },
      true
    ).then(({ data }) => {
      setAllowConfirmMonthYear(data);
    }).catch(() => {
    });
  }, [filter.monthYear])


  const [view, setView] = useState({
    confirm: false,
    pitFee: false,
  });

  const toggle = (type) => {
    setView({
      ...view,
      [type]: !view[type],
    });
  };

  const onFormCancel = () => {
    setView({
      confirm: false,
      pitFee: false,
    });
    setPitFee(null);
  };

  useEffect(() => {
    const newParams = new URLSearchParams({
      monthYear: filter.monthYear,
    });
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    })

    const params = {
      monthYear: filter.monthYear,
    }

    GET(
      `/pn/report-all-driver-salary`,
      params,
      true
    ).then((resp) => {
      const { data: { tx: { rows, summary }, nvvp, cn } } = resp;
      setDataDriver(rows);
      setSummaryDriver(summary);
      setDataNvvp(nvvp.rows)
      setSummaryNvvp(nvvp.summary)
      setDataCn(cn.rows)
      setSummaryCn(cn.summary)
    });
  }, [filter, updatedAt]);

  const colTableDriver = [
    {
      Header: "Tên khách hàng",
      accessor: (item) => (item.name),
    },
    {
      Header: "Ngày nghỉ",
      sortable: true,
      className: 'text-right',
      accessor: (item) => (
        <NumericFormat
          displayType={"text"}
          value={item.leaveDay || 0}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={0}
        />
      ),
    },
    {
      Header: "Lương cơ bản(đ)",
      className: 'text-right',
      accessor: (item) => (
        <NumericFormat
          displayType={"text"}
          value={item.baseSalary || 0}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={0}
        />
      ),
    },
    {
      Header: "Ăn(đ)",
      className: 'text-right',
      accessor: (item) => (
        <NumericFormat
          displayType={"text"}
          value={item.foodAllowance || 0}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={0}
        />
      ),
    },
    {
      Header: "Xăng Xe(đ)",
      className: 'text-right',
      accessor: (item) => (
        <NumericFormat
          displayType={"text"}
          value={item.travelAllowance || 0}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={0}
        />
      ),
    },
    {
      Header: "Nhà ở(đ)",
      className: 'text-right',
      accessor: (item) => (
        <NumericFormat
          displayType={"text"}
          value={item.housingSubsidy || 0}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={0}
        />
      ),
    },
    {
      Header: "Trợ cấp điện thoại(đ)",
      className: 'text-right',
      accessor: (item) => (
        <NumericFormat
          displayType={"text"}
          value={item.telephoneAllowance || 0}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={0}
        />
      ),
    },
    {
      Header: "Lương chuyến(đ)",
      className: 'text-right',
      accessor: (item) => (
        <NumericFormat
          displayType={"text"}
          value={item.driverBonus || 0}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={0}
        />
      ),
    },
    {
      Header: "Tổng thu nhập(đ)",
      className: 'text-right font-weight-bold',
      accessor: (item) => (
        <NumericFormat
          displayType={"text"}
          value={item.grossSalary || 0}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={0}
        />
      ),
    },
    {
      Header: "Chi phí cá nhân(đ)",
      className: 'text-right',
      hideFromJuly2026: true,
      accessor: (item) => (
        <NumericFormat
          displayType={"text"}
          value={item.personalCost || 0}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={0}
        />
      ),
    },
    {
      Header: "Cấn trừ chi phí (đ)",
      className: 'text-right',
      accessor: (item) => (
        <NumericFormat
          displayType={"text"}
          value={(item.personalCostOut || 0) * -1}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={0}
        />
      ),
    },
    {
      Header: `${PN_STATIC_CATEGORY_SALARY_FOR_DRIVER_NAME[PN_STATIC_CATEGORY_SALARY_FOR_DRIVER.ADVANCE_SALARY]}(đ)`,
      className: 'text-right',
      hideFromJuly2026: true,
      accessor: (item) => (
        <NumericFormat
          displayType={"text"}
          value={(item?.personalInDetail?.[PN_STATIC_CATEGORY_SALARY_FOR_DRIVER.ADVANCE_SALARY] || 0) * -1}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={0}
        />
      ),
    },
    {
      Header: `${PN_STATIC_CATEGORY_SALARY_FOR_DRIVER_NAME[PN_STATIC_CATEGORY_SALARY_FOR_DRIVER.INSURANCE_FEE]}(đ)`,
      className: 'text-right',
      accessor: (item) => (
        <NumericFormat
          displayType={"text"}
          value={(item?.personalInDetail?.[PN_STATIC_CATEGORY_SALARY_FOR_DRIVER.INSURANCE_FEE] || 0) * -1}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={0}
        />
      ),
    },
    {
      Header: "Người phụ thuộc",
      className: 'text-right',
      accessor: (item) => (
        <NumericFormat
          displayType={"text"}
          value={item.dependents || 0}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={0}
        />
      ),
    },
    {
      Header: "Giảm trừ gia cảnh (đ)",
      className: 'text-right',
      accessor: (item) => (
        <NumericFormat
          displayType={"text"}
          value={item.pitDeduction || 0}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={0}
        />
      ),
    },
    {
      Header: "Thu nhập tính thuế (đ)",
      className: 'text-right',
      accessor: (item) => (
        <NumericFormat
          displayType={"text"}
          value={item.assessableIncome || 0}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={0}
        />
      ),
    },
    {
      Header: `${PN_STATIC_CATEGORY_SALARY_FOR_DRIVER_NAME[PN_STATIC_CATEGORY_SALARY_FOR_DRIVER.PIT_FEE]}(đ)`,
      className: 'text-right',
      accessor: (item) => (
        <NumericFormat
          displayType={"text"}
          value={(item?.personalInDetail?.[PN_STATIC_CATEGORY_SALARY_FOR_DRIVER.PIT_FEE] || 0) * -1}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={0}
        />
      ),
    },
    // {
    //   Header: `${PN_STATIC_CATEGORY_SALARY_FOR_DRIVER_NAME[PN_STATIC_CATEGORY_SALARY_FOR_DRIVER.UNION_FEE]}(đ)`,
    //   className: 'text-right',
    //   accessor: (item) => (
    //     <NumericFormat
    //       displayType={"text"}
    //       value={(item?.personalInDetail?.[PN_STATIC_CATEGORY_SALARY_FOR_DRIVER.UNION_FEE] || 0) * -1}
    //       thousandsGroupStyle="thousand"
    //       thousandSeparator=","
    //       decimalScale={0}
    //     />
    //   ),
    // },

    {
      Header: "Thực nhận(đ)",
      className: 'text-right',
      accessor: (item) => (
        <NumericFormat
          displayType={"text"}
          value={item.netSalary || 0}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={0}
        />
      ),
    },
  ].filter((col) => !(col.hideFromJuly2026 && hidePersonalCostAndAdvance));

  const exportExcel = () => {
    const params = new URLSearchParams({
      monthYear: filter.monthYear,
      token: getToken(),

    })
    const url = `${process.env.REACT_APP_API_URL}/api/v1/pn/report-all-driver-salary-excel?${params.toString()}`;
    window.open(url, '_blank')
  };

  const confirmSalary = () => {
    POST(
      `/pn/confirm-salary`,
      { monthYear: filter.monthYear },
      {},
      true
    ).then(() => {
      toast.success('Xác nhận lương tháng thành công')
      setAllowConfirmMonthYear(false);
    }).catch(() => {
      toast.error('Không thể xác nhận lương tháng này')
    }).finally(() => {
      toggle('confirm');
    });
  }


  return (
    <React.Fragment>
      <Head title="Báo cáo"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Báo cáo</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div className="form-control-wrap">
                        <input
                          type="month"
                          className="form-control  border-primary"
                          value={filter.monthYear}
                          onChange={(e) =>
                            setFilter({
                              ...filter,
                              monthYear: e.target.value,
                            })
                          }
                        />
                      </div>
                    </li>
                    <li>
                      <div className="d-inline-block mr-3">
                        <ReactToPrint
                          trigger={() => <Button>In</Button>}
                          content={() => printRef.current}
                          pageStyle={``}
                        />
                        <Button onClick={exportExcel} className="ml-3">
                          Xuất excel
                        </Button>
                      </div>
                    </li>
                    {allowConfirmMonthYear ? <li>
                      <div className="d-inline-block mr-3">
                        <Button onClick={() => {
                          toggle("confirm")
                        }} className="ml-3">
                          Xác nhận tháng này
                        </Button>
                      </div>
                    </li> : <></>}
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div
            id="DataTables_Table_1_wrapper"
            className="dataTables_wrapper dt-bootstrap4 no-footer bg-white"
          >
            <div className="my-3">
              <Row>
                <Col md={12}>
                  <div ref={printRef}>
                    <h5 className="text-center mt-2">
                      CÔNG TY TNHH CƠ KHÍ VẬN TẢI PHƯƠNG NAM
                    </h5>
                    <h5 className="text-center">Tổng hợp lương tài xế tháng {moment(filter.monthYear, 'YYYY-MM').format('MM-YYYY')}</h5>
                    <style>{renderPageStyle({
                      fontSize: 7
                    })}</style>

                    <Table
                      columns={colTableDriver}
                      data={dataDriver}
                      notShowPagi={true}
                      isRotate
                      customRow={() =>
                        <tr className="font-weight-bold">
                          <td><span>Tổng(đ)</span></td>

                          <td className="text-right">
                            <NumericFormat
                              displayType={"text"}
                              value={summaryDriver.leaveDay || 0}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={0}
                            />
                          </td>
                          <td className="text-right">
                            <NumericFormat
                              displayType={"text"}
                              value={summaryDriver.baseSalary || 0}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={0}
                            />
                          </td>
                          <td className="text-right">
                            <NumericFormat
                              displayType={"text"}
                              value={summaryDriver.foodAllowance || 0}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={0}
                            />
                          </td>
                          <td className="text-right">
                            <NumericFormat
                              displayType={"text"}
                              value={summaryDriver.travelAllowance || 0}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={0}
                            />
                          </td>
                          <td className="text-right">
                            <NumericFormat
                              displayType={"text"}
                              value={summaryDriver.housingSubsidy || 0}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={0}
                            />
                          </td>
                          <td className="text-right">
                            <NumericFormat
                              displayType={"text"}
                              value={summaryDriver.telephoneAllowance || 0}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={0}
                            />
                          </td>

                          <td className="text-right">
                            <NumericFormat
                              displayType={"text"}
                              value={summaryDriver.driverBonus || 0}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={0}
                            />
                          </td>


                          <td className="text-right">
                            <NumericFormat
                              displayType={"text"}
                              value={summaryDriver.grossSalary || 0}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={0}
                            />
                          </td>
                          {!hidePersonalCostAndAdvance && (
                            <td className="text-right">
                              <NumericFormat
                                displayType={"text"}
                                value={summaryDriver.personalCost || 0}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={0}
                              />
                            </td>
                          )}
                          <td className="text-right">
                            <NumericFormat
                              displayType={"text"}
                              value={(summaryDriver.personalCostOut || 0) * -1}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={0}
                            />
                          </td>
                          {!hidePersonalCostAndAdvance && (
                            <td className="text-right">
                              <NumericFormat
                                displayType={"text"}
                                value={(summaryDriver?.personalInDetail?.[PN_STATIC_CATEGORY_SALARY_FOR_DRIVER.ADVANCE_SALARY] || 0) * -1}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={0}
                              />
                            </td>
                          )}
                          <td className="text-right">
                            <NumericFormat
                              displayType={"text"}
                              value={(summaryDriver?.personalInDetail?.[PN_STATIC_CATEGORY_SALARY_FOR_DRIVER.INSURANCE_FEE] || 0) * -1}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={0}
                            />
                          </td>
                          <td className="text-right">
                            <NumericFormat
                              displayType={"text"}
                              value={(summaryDriver.dependents || 0)}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={0}
                            />
                          </td>
                          <td className="text-right">
                            <NumericFormat
                              displayType={"text"}
                              value={(summaryDriver.pitDeduction || 0)}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={0}
                            />
                          </td>
                          <td className="text-right">
                            <NumericFormat
                              displayType={"text"}
                              value={(summaryDriver.assessableIncome || 0)}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={0}
                            />
                          </td>
                          <td className="text-right">
                            <NumericFormat
                              displayType={"text"}
                              value={(summaryDriver?.personalInDetail?.[PN_STATIC_CATEGORY_SALARY_FOR_DRIVER.PIT_FEE] || 0) * -1}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={0}
                            />
                          </td>
                          {/* <td className="text-right">
                            <NumericFormat
                              displayType={"text"}
                              value={(summaryDriver?.personalInDetail?.[PN_STATIC_CATEGORY_SALARY_FOR_DRIVER.UNION_FEE] || 0) * -1}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={0}
                            />
                          </td> */}
                          <td className="text-right">
                            <NumericFormat
                              displayType={"text"}
                              value={summaryDriver.netSalary || 0}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={0}
                            />
                          </td>
                        </tr>
                      }
                    ></Table>

                    <h5 className="text-center mt-2 mb-2">Báo cáo lương Công nhân {filter?.monthYear} công ty</h5>
                    <Table
                      columns={colTableCn({
                        onDoubleClickPit: (item) => {
                          setView({
                            ...view,
                            pitFee: true,
                          })
                          setPitFee({
                            user: item.user,
                            amount: item?.pit || 0
                          });
                        }
                      })}
                      data={dataCn}
                      notShowPagi
                      isRotate
                      customRow={() => <tr className="font-weight-bold">
                        <td><span>Tổng cộng</span></td>
                        <td className=" text-right"><span>|</span></td>
                        <td className=" text-right">
                          <NumericFormat
                            displayType={"text"}
                            value={summaryCn.workingDay || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={2}
                          />
                        </td>
                        <td className=" text-right"><span>|</span></td>
                        <td className=" text-right"><span>|</span></td>
                        <td className=" text-right">
                          <NumericFormat
                            displayType={"text"}
                            value={summaryCn.extraAndBonusHour || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={2}
                          />
                        </td>
                        {[...new Array(17)].map((_, i) => <td key={i} className=" text-right"><span>|</span></td>)}
                        <td className=" text-right">
                          <NumericFormat
                            displayType={"text"}
                            value={summaryCn.productivitySalary || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={0}
                          />
                        </td>
                        <td className=" text-right">
                          <NumericFormat
                            displayType={"text"}
                            value={summaryCn.extraAndBonusSalary || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={0}
                          />
                        </td>
                        <td className=" text-right">
                          <NumericFormat
                            displayType={"text"}
                            value={summaryCn.extraHourFoodAllowance || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={0}
                          />
                        </td>

                        <td className=" text-right">
                          <NumericFormat
                            displayType={"text"}
                            value={summaryCn.anotherBonus || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={0}
                          />
                        </td>
                        <td className=" text-right">
                          <NumericFormat
                            displayType={"text"}
                            value={(summaryCn.insuranceLeaveFee || 0) * -1}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={0}
                          />
                        </td>
                        <td className=" text-right">
                          <NumericFormat
                            displayType={"text"}
                            value={summaryCn.grossSalary || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={0}
                          />
                        </td>

                        <td className=" text-right">
                          <NumericFormat
                            displayType={"text"}
                            value={(summaryCn.insuranceFee || 0) * -1}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={0}
                          />
                        </td>
                        <td className=" text-right">
                          <NumericFormat
                            displayType={"text"}
                            value={summaryCn.taxableIncome || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={0}
                          />
                        </td>
                        <td className=" text-right">
                          <NumericFormat
                            displayType={"text"}
                            value={summaryCn.dependents || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={0}
                          />
                        </td>
                        <td className=" text-right">
                          <NumericFormat
                            displayType={"text"}
                            value={summaryCn.pitDeduction || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={0}
                          />
                        </td>
                        <td className=" text-right">
                          <NumericFormat
                            displayType={"text"}
                            value={summaryCn.assessableIncome || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={0}
                          />
                        </td>
                        <td className=" text-right">
                          <NumericFormat
                            displayType={"text"}
                            value={(summaryCn.pit || 0) * -1}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={0}
                          />
                        </td>
                        {/* <td className=" text-right">
                          <NumericFormat
                            displayType={"text"}
                            value={(summaryCn.unionFee || 0) * -1}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={0}
                          />
                        </td> */}
                        <td className=" text-right">
                          <NumericFormat
                            displayType={"text"}
                            value={(summaryCn.anotherFee || 0) * -1}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={0}
                          />
                        </td>

                        <td className=" text-right">
                          <NumericFormat
                            displayType={"text"}
                            value={summaryCn.finalSalary || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={0}
                          />
                        </td>
                      </tr>}
                    ></Table>

                    <h5 className="text-center mt-2 mb-2">Báo cáo lương nhân viên văn phòng tháng {filter?.monthYear}</h5>
                    <Table
                      columns={colTableNvvp()}
                      data={dataNvvp}
                      notShowPagi
                      isRotate

                      customRow={() => <tr className="font-weight-bold">
                        <td ><span>Tổng cộng</span></td>
                        {[...new Array(9)].map(() => <td className=" text-right">
                          <span>|</span>
                        </td>)}

                        <td className=" text-right">
                          <NumericFormat
                            displayType={"text"}
                            value={summaryNvvp.productivitySalary || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={0}
                          />
                        </td>
                        <td className=" text-right">
                          <NumericFormat
                            displayType={"text"}
                            value={summaryNvvp.anotherBonus || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={0}
                          />
                        </td>
                        <td className=" text-right">
                          <NumericFormat
                            displayType={"text"}
                            value={(summaryNvvp.insuranceLeaveFee || 0) * -1}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={0}
                          />
                        </td>
                        <td className=" text-right">
                          <NumericFormat
                            displayType={"text"}
                            value={summaryNvvp.grossSalary || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={0}
                          />
                        </td>

                        <td className=" text-right">
                          <NumericFormat
                            displayType={"text"}
                            value={(summaryNvvp.insuranceFee || 0) * -1}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={0}
                          />
                        </td>
                        <td className=" text-right">
                          <NumericFormat
                            displayType={"text"}
                            value={summaryNvvp.taxableIncome || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={0}
                          />
                        </td>

                        <td className=" text-right">
                          <NumericFormat
                            displayType={"text"}
                            value={summaryNvvp.dependents || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={0}
                          />
                        </td>
                        <td className=" text-right">
                          <NumericFormat
                            displayType={"text"}
                            value={summaryNvvp.pitDeduction || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={0}
                          />
                        </td>
                        <td className=" text-right">
                          <NumericFormat
                            displayType={"text"}
                            value={summaryNvvp.assessableIncome || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={0}
                          />
                        </td>
                        <td className=" text-right">
                          <NumericFormat
                            displayType={"text"}
                            value={(summaryNvvp.pit || 0) * -1}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={0}
                          />
                        </td>
                        {/* <td className=" text-right">
                          <NumericFormat
                            displayType={"text"}
                            value={(summaryNvvp.unionFee || 0) * -1}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={0}
                          />
                        </td> */}
                        <td className=" text-right">
                          <NumericFormat
                            displayType={"text"}
                            value={(summaryNvvp.anotherFee || 0) * -1}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={0}
                          />
                        </td>

                        <td className=" text-right">
                          <NumericFormat
                            displayType={"text"}
                            value={summaryNvvp.finalSalary || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={0}
                          />
                        </td>
                      </tr>}
                    ></Table>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Block>
      </Content>
      <Modal isOpen={view.confirm} toggle={() => toggle('confirm')}>
        <ModalBody className="modal-body-lg text-center">
          <div className="nk-modal">
            <Icon className="nk-modal-icon icon-circle icon-circle-xxl ni ni-check bg-success"></Icon>
            <h4 className="nk-modal-title">
              Bạn có chắc muốn xác nhận tháng này không?{" "}
            </h4>
            <div className="nk-modal-action mt-5 d-flex justify-content-around">
              <Button
                color="light"
                size="lg"
                className="btn-mw mr-5"
                onClick={() => toggle('confirm')}
              >
                Huỷ bỏ
              </Button>
              <Button
                color="primary"
                size="lg"
                className="btn-mw"
                onClick={(ev) => {
                  ev.preventDefault();
                  confirmSalary();
                }}
              >
                Xác nhận
              </Button>
            </div>
          </div>
        </ModalBody>
      </Modal>
      {
        view.pitFee && pitFee && <UpsertPITFeeComponent
          onCancel={() => onFormCancel()}
          onSuccess={() => {
            onFormCancel();
            setUpdatedAt(moment().valueOf());
          }}
          data={{
            ...pitFee,
            date: moment(filter.monthYear, 'YYYY-MM').startOf('month').format('YYYY-MM-DD'),
          }}
        />
      }
    </React.Fragment>
  );
};

export default PNReportDriverSalary;
